import * as React from 'react'

type TableTextRowProps = {
  children?: React.ReactNode
  icon?: React.ReactNode
  size?: 'small' | 'medium' | 'compact'
  bolder?: boolean
  textSize?: string
  className?: string
  pointer?: boolean
}

const TableTextRow: React.FC<TableTextRowProps> = ({
  children,
  icon,
  size = 'medium',
  bolder = true,
  textSize = 'sm',
  pointer = true,
  className = '',
}) => {
  const isSmall = size === 'small'
  const isCompact = size === 'compact'
  return (
    <td
      className={` ${pointer ? 'tw-cursor-pointer' : 'tw-cursor-default'} ${isCompact ? 'tw-py-3 tw-pl-2.5 tw-pr-3' : isSmall ? 'tw-px-3 tw-py-2.5' : 'tw-py-3.5 tw-pl-2.5 tw-pr-3'} tw-text-content-base tw-opacity-90 ${className}`}
    >
      <div
        className={`tw-flex tw-items-center tw-gap-2 tw-text-nowrap ${textSize && `tw-text-${textSize}`} ${bolder && 'tw-font-medium'}`}
      >
        {icon && (
          <span className="tw-flex-shrink-0 tw-text-content-base">{icon}</span>
        )}
        {children}
      </div>
    </td>
  )
}
export default TableTextRow
